import { useSelector } from 'react-redux'
import StateType from '../../utils/types/states'

const selectUsers = (state: StateType) => state.admin.users
const selectLoadingUsers = (state: StateType) => state.admin.loading

export const useUsersList: () => any | [] = () => useSelector(selectUsers)
export const useLoadingUsers: () => boolean = () => useSelector(selectLoadingUsers)
